export default "__VITE_ASSET__CWsn$bTW__"